import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPaymentItem.Find.IRequest;
type Response = Api.Finance.ClaimJobPaymentItem.Find.IResponse;
type Headers = Api.Finance.ClaimJobPaymentItem.Find.IHeaders;
const url = '/api/Finance/ClaimJobPaymentItem/:id';
export default async function claimJobPaymentItemFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
